/*
 * Each mobile view should have the following in the BodyScripts section:
 * 
 * @section BodyScripts {
 *         <script>
 *             window.nativeHook.setNavBar({
 *                 text: 'Disclosure',
 *                 left: { button: 'back', callback: 'window.location.href = "\Mobile\Disclosures"' },
 *                 right: { button: 'custom', text: 'Agree', callback: '$("form#mobile_disclosure").submit()' }
 *             });
 *         </script>
 * }
 * 
 * 
 * "text" is the title that will be shown in the native header bar
 * "left" defines the button that will be shown on the left side of the native header bar (usually drawer or back)
 * "right" defines the button that will be shown on the right side of the native header bar
 * 
 * There are some pre-defined button icons that can be used by putting the name in the button 
 * property of left or right. They are "drawer" which is for the slide-out menu, "home", "back", 
 * and "close" which is an X icon.  If it's not one of those buttons, use "custom" for the 
 * button property and set the text property to the text of the button.
 * 
 * "callback" defines a javascript statement that iOS/Android will execute when that button is 
 * touched natively.
 * 
 * If the header bar title or buttons need to be changed after the view has loaded such as when 
 * showing or hiding divs to simulate a page change, you can trigger a native update with the 
 * following javascript:
 * 
 *             window.nativeHook.updateNavBar({
 *                 text: 'Message Center',
 *                 left: { button: 'drawer' },
 *                 right: { button: 'custom', text: 'Done', callback: 'messageCenterWidget.toggleEditor()' }
 *             });
 * 
 */

(function (window) {
    var navigationBarJson;

    var isNativeApp = navigator.userAgent ? /nativeapp/.test(navigator.userAgent.toLowerCase()) : false;
    var isNativeAppWithNativeMenu = navigator.userAgent ? /nativemenu/.test(navigator.userAgent.toLowerCase()) : false;
    var isAndroid = navigator.userAgent ? /android/.test(navigator.userAgent.toLowerCase()) : false;
    var isReadyForRefresh = isAndroid; // if we are android, we can immediatly send updates

    function forceRefreshNavBar() {
        if (isReadyForRefresh && isNativeAppWithNativeMenu) {
            window.location.href = "refresh-nav://alkamitech.com";
        }
    }

    window.nativeHook = {
        isAndroid: function() {
            return isAndroid;
        },

        isNativeApp: function () {
            return isNativeApp;
        },

        isNativeAppWithNativeMenu: function () {
            return isNativeAppWithNativeMenu;
        },

        setNavBar: function (navBarJson) {
            navigationBarJson = navBarJson;
        },

        getNavBar: function() {
            return navigationBarJson;
        },

        getNavBarString: function () {
            /* 
            *  DEV-109285
            *  As of iOS 14.2, there is an issue where the web view is not ready for refreshing until 
            *  the `didFinishNavigation` delegate is called. At that point we know that iOS uses `getNavBarString`
            *  to grab information from the web view for the nav bar and consistently works.
            *  So the fix is to wait until the first time iOS does this call to start allowing the apps
            *  to control the update of the UI
            */

            if(!isReadyForRefresh && !isAndroid && isNativeAppWithNativeMenu) {
                isReadyForRefresh = true;
            }
            
            return JSON.stringify(navigationBarJson);
        },

        updateNavBar: function (navBarJson) {
            if (navigationBarJson === navBarJson)
                return;

            navigationBarJson = navBarJson;
            
            forceRefreshNavBar();
        }
    };

})(this);